import React from 'react';
import styled from 'styled-components';
import { Avatar, AvatarSkeleton, Icon } from '@oneaudi/unified-web-components';
import { useProfilePicture } from '../../hooks/use-profile-picture';
import { NAVIGATION_CLASSNAME } from '../../utils/globals';
import type { IdkConfig } from '../../hooks/use-env-config';

const StyledAvatarSkeleton = styled(AvatarSkeleton)<{
  isLegacy: boolean;
}>`
  margin-top: 0;
`;

const StyledAvatar = styled(Avatar)`
  & img {
    position: inherit;
  }
  background-color: var(--one-header-color-black);
  margin: 0;
`;

const StyledIcon = styled(Icon)<{
  isLegacy: boolean;
}>`
  cursor: pointer;
  margin-top: ${({ theme, isLegacy }): string => (isLegacy ? '0' : theme.spacing.s)};
`;

const AvatarIcon: React.FC<{
  idk: IdkConfig | undefined;
  initials: string;
  flyoutLabel: string;
  loading: boolean;
  error: string | null;
}> = ({ idk, initials, flyoutLabel, loading, error }) => {
  const isLegacy = Boolean(process.env.IS_LEGACY);
  const profilePicture = useProfilePicture(idk);

  if (error && typeof error === 'string') {
    return <StyledIcon isLegacy={isLegacy} name="user-active" size="s" data-testid="StyledIcon" />;
  }

  if (loading || profilePicture?.loading) {
    return <StyledAvatarSkeleton isLegacy={isLegacy} size="sm" data-testid="AvatarSkeleton" />;
  }

  return profilePicture?.src ? (
    <StyledAvatar
      aria-label={flyoutLabel}
      size="sm"
      label={initials}
      image={{
        src: profilePicture.src,
        alt: 'profile picture',
        role: 'presentation',
      }}
      variant="logged-in"
      onClick={() => {}}
      data-testid="StyledAvatar"
      className={NAVIGATION_CLASSNAME}
    />
  ) : (
    <>
      {initials ? (
        <StyledAvatar
          aria-label={flyoutLabel}
          size="sm"
          label={initials}
          variant="logged-in"
          onClick={() => {}}
          data-testid="StyledAvatar"
          className={NAVIGATION_CLASSNAME}
        />
      ) : (
        <StyledIcon isLegacy={isLegacy} name="user-active" size="s" data-testid="StyledIcon" />
      )}
    </>
  );
};

export default AvatarIcon;
